import {isPlatformBrowser} from '@angular/common';
import {ReservationsService} from '../../_services/reservations/reservations.service';
import {OpeningHoursService} from '../../_services/opening-hours/opening-hours.service';
import {ReservationTables} from '../../../_models/reservation-tables';
import {MatSelectOption} from './../../../_models/mat-select-option';
import {Table} from './../../../_models/table';
import {GARDEN_COMBOS, RESTAURANT_COMBOS, getCapacityBucket,} from '../../../_models/table-combinations';
import {OpeningHour} from '../../../_models/opening-hour';
import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID,} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators,} from '@angular/forms';
import { addDays, addHours, addMinutes, differenceInDays } from 'date-fns';
import { formatDateWarsaw, formatTimeWarsaw, getISODayInWarsaw, isSameDayInWarsaw, toWarsawSlot } from '../../_services/reservations/warsaw-timezone.helper';
import {finalize, forkJoin, map, Observable, of, startWith, Subscription, switchMap} from 'rxjs';
import {ReservationWithTables, ReservationWithTablesRequest,} from '../../../_models/reservation';
import {MatSnackBar} from "@angular/material/snack-bar";
import {SpecialDayService} from "../../_services/special-days/special-day.service";
import {SpecialDay} from "../../../_models/special_day";
import {Router} from "@angular/router";

interface PhoneCode {
  code: string;
  country: string;
}

interface SlotAvailability {
  tables: Table[];
  isGarden: boolean;
}

interface NextAvailableSlot {
  date: Date;
  startDate: Date;
  isGarden: boolean;
  tables: Table[];
}

const RESERVATION_GAP_MINUTES = 30;
const SEARCH_DAYS_AHEAD = 14;

@Component({
  selector: 'app-create-reservation',
  templateUrl: './create-reservation.component.html',
  styleUrls: ['./create-reservation.component.scss'],
  standalone: false,
})
export class CreateReservationComponent implements OnInit {
  @Input() reservationDate: Date;
  @Input() reservation: ReservationWithTables;
  @Input() reservationStep: number = 1;
  @Input() admin = false;
  @Input() isGardenSeason = true;
  @Output() stepChanged = new EventEmitter<number>();
  @Output() backToChange = new EventEmitter<void>();
  @Input() isRestaurant: boolean = true;
  tables: Table[] = [];
  allTables: Table[] = [];
  restaurantUpTablesId = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  restaurantDownTablesId = [10, 11, 12, 13, 14, 15, 16, 17, 18];
  gardenOneLineTablesId = [20, 21, 22, 23];
  gardenTwoLineTablesId = [24, 25, 26, 27, 28];
  gardenThreeLineTablesId = [29, 30, 31, 32, 33];

  // Kombinacje stolikow (allow-lista klienta) sa w ../../../_models/table-combinations
  // — wspoldzielone z importem GoPOS po stronie backendu.
  isHasGapError = false;
  openingHours: OpeningHour[] = [];
  reservationForm: FormGroup;
  daysOptions: MatSelectOption<Date>[] = [];
  hoursOptions: MatSelectOption<Date>[] = [];
  guestsAmountOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
  st1: any;
  st2: any;
  st3: any;
  st4: any;

  st5: any;
  st6: any;
  st7: any;
  st8: any;

  st9: any;
  st10: any;
  st11: any;
  st12: any;

  phoneCodes: PhoneCode[] = [
    { code: '+48', country: 'Polska' },
    { code: '+49', country: 'Niemcy' },
    { code: '+43', country: 'Austria' },
    { code: '+44', country: 'Wielka Brytania' },
    { code: '+33', country: 'Francja' },
    { code: '+34', country: 'Hiszpania' },
    { code: '+39', country: 'Włochy' },
    { code: '+31', country: 'Holandia' },
    { code: '+32', country: 'Belgia' },
    { code: '+41', country: 'Szwajcaria' },
    { code: '+420', country: 'Czechy' },
    { code: '+421', country: 'Słowacja' },
    { code: '+36', country: 'Węgry' },
    { code: '+45', country: 'Dania' },
    { code: '+46', country: 'Szwecja' },
    { code: '+47', country: 'Norwegia' },
    { code: '+358', country: 'Finlandia' },
    { code: '+372', country: 'Estonia' },
    { code: '+371', country: 'Łotwa' },
    { code: '+370', country: 'Litwa' },
    { code: '+380', country: 'Ukraina' },
    { code: '+375', country: 'Białoruś' },
    { code: '+7',   country: 'Rosja / Kazachstan' },
    { code: '+1',   country: 'USA / Kanada' },
    { code: '+52',  country: 'Meksyk' },
    { code: '+55',  country: 'Brazylia' },
    { code: '+86',  country: 'Chiny' },
    { code: '+81',  country: 'Japonia' },
    { code: '+82',  country: 'Korea Płd.' },
    { code: '+91',  country: 'Indie' },
    { code: '+61',  country: 'Australia' },
    { code: '+971', country: 'ZEA' },
    { code: '+966', country: 'Arabia Saudyjska' },
    { code: '+234', country: 'Nigeria' },
    { code: '+27',  country: 'RPA' },
  ];

  /** Stara lista – zachowana dla zgodności z istniejącym walidatorem. */
  codePhoneNumber: string[] = this.phoneCodes.map((c) => c.code);
  subscriptions: Subscription[] = [];
  reservationTables: ReservationTables[];
  sendingReservation = false;
  private readonly CLIENT_SAVED_DATA = 'client_saved_data_with_code';
  private readonly RESERVATION_SAVED_DATA = 'reservation_saved_data';
  filteredCodeNumber: Observable<PhoneCode[]>;

  defaultClientData = {
    firstName: '',
    surname: '',
    phoneNumber: '',
    email: '',
    code: '+48',
    marketingConsent: false,
  };
  defaultReservationData = {
    tables: [] as Table[],
    dateDay: new Date(),
    startDate: '',
    guestsAmount: 2,
  };
  reservationsNotActive: boolean;
  endHoursOptions: MatSelectOption<Date>[];
  specialDays: SpecialDay[] = [];
  isGardenOpen: boolean = true;

  availabilityState: 'idle' | 'searching' | 'available' | 'not_available' | 'no_availability_in_period' = 'idle';
  availabilityIsGarden = false;

  /**
   * Tryb doboru stolika przez kelnera (tylko widok admina). 'manual' = dotychczasowe
   * klikanie po rzucie sali, 'auto' = system dobiera stolik wg tych samych
   * kombinacji co ścieżka klienta. Domyślnie 'manual', żeby nie zmieniać
   * dotychczasowego zachowania panelu.
   */
  adminTableMode: 'manual' | 'auto' = 'manual';
  /** Tryb auto: nie udało się dobrać stolika dla podanej liczby gości/godziny. */
  adminAutoAssignError = false;
  nextAvailableSlot: NextAvailableSlot | null = null;
  /** Anuluje poprzednie wyszukiwanie wolnego terminu gdy użytkownik zmieni parametry. */
  private nextSlotSearchSubscription: Subscription | null = null;
  /**
   * Godzina, którą chcemy ustawić po przebudowaniu listy godzin dla nowego dnia
   * (używane przy „Wybierz ten termin"). Zmiana dnia odpala async pobranie
   * stolików, które inaczej nadpisałoby startDate pierwszą godziną otwarcia.
   */
  private pendingStartDate: Date | null = null;

  /** Dostępność stolików w lokalu dla aktualnie wybranego slotu. */
  restaurantSlot: SlotAvailability | null = null;
  /** Dostępność stolików w ogródku dla aktualnie wybranego slotu (null gdy poza sezonem lub brak miejsc). */
  gardenSlot: SlotAvailability | null = null;
  /** Czy ogródek jest w ogóle dostępny w wybranym dniu (sezon + opening hours). */
  gardenAllowedToday = false;

  constructor(
    private reservationsService: ReservationsService,
    private openingHoursService: OpeningHoursService,
    private snackBar: MatSnackBar,
    private specialDayService: SpecialDayService,
    private route: Router,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
  }

  async ngOnInit(): Promise<void> {
    const specialDays = await this.specialDayService.getSpecialDays().toPromise();
    if (specialDays) {
      specialDays.forEach(day => day.specialDate = new Date(day.specialDate));
      this.specialDays = specialDays;
    }

    forkJoin([
      this.reservationsService.getTables(),
      this.openingHoursService.getOpeningHours(),
    ]).subscribe(([tables, openingHours]) => {
      this.allTables = tables;
      if (this.admin) {
        this.tables = this.isRestaurant
          ? tables.filter(table => !table.isGardenOpen)
          : tables.filter(table => table.isGardenOpen);
      } else {
        this.tables = tables;
      }
      this.openingHours = openingHours;
      this.daysOptions =
        this.reservationsService.prepareDaysOptions(openingHours, this.specialDays);
      if (this.reservationDate) {
        this.prepareReservationsForDay(
          this.reservationDate,
          this.openingHours,
          this.defaultClientData
        );
      } else {
        if (isPlatformBrowser(this.platformId)) {
          const clientDataFromLocalStorage = localStorage.getItem(
            this.CLIENT_SAVED_DATA
          );
          if (clientDataFromLocalStorage) {
            this.defaultClientData = {
              ...this.defaultClientData,
              ...JSON.parse(clientDataFromLocalStorage),
            };
          }

          const reservationDataFromLocalStorage = localStorage.getItem(
            this.RESERVATION_SAVED_DATA
          );
          if (reservationDataFromLocalStorage) {
            this.defaultReservationData = {
              ...this.defaultReservationData,
              ...JSON.parse(reservationDataFromLocalStorage),
            };
            this.defaultReservationData.tables = this.tables.filter((table) =>
              this.defaultReservationData.tables
                .map((tab) => tab.id)
                .includes(table.id)
            );
            const reservationDefaultData = new Date(
              this.defaultReservationData.dateDay
            );
            this.defaultReservationData.dateDay =
              this.isDateInPast(reservationDefaultData) ?
                new Date() :
                reservationDefaultData;
          }
        }
        this.prepareReservationsForDay(
          this.reservationDate ?
            this.reservationDate : this.defaultReservationData.dateDay ?
              this.defaultReservationData.dateDay :
              this.daysOptions.map(option => option.value)[0],
          this.openingHours,
          this.defaultClientData,
          this.defaultReservationData
        );
      }
    });
  }

  private _filter(value: string | null): PhoneCode[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.phoneCodes.filter(option =>
        option.code.toLowerCase().includes(filterValue) ||
        option.country.toLowerCase().includes(filterValue)
      );
    }
    return this.phoneCodes;
  }

  private prepareReservationsForDay(
    reservationDate: Date,
    openingHours: OpeningHour[],
    defaultClientData: any,
    defaultReservationData?: any
  ) {
    this.reservationsService
      .getReservationTables(toWarsawSlot(reservationDate, 0))
      .subscribe((reservationTables) => {
        // Wykluczamy status 2 (gość nie przybył) – zwalnia stolik. Status 4
        // (gość wyszedł) NIE jest wykluczany: liczy się nadal, ale z krótszym
        // czasem końca (left_at) + 30 min bufora – patrz getReservationTables.
        reservationTables = reservationTables.filter(reservation => reservation.status !== 2);
        this.reservationTables = reservationTables;
        let selectedHoursOption: MatSelectOption<Date>;

        const selectedDate = this.getDate(
          defaultReservationData
            ? defaultReservationData.dateDay
            : reservationDate
        );
        this.setGardenOpenForDay(selectedDate.value);
        this.hoursOptions = this.getHours(
          selectedDate.value,
          openingHours);
        this.endHoursOptions = this.getHours(
          selectedDate.value,
          openingHours,
          0
        );
        selectedHoursOption = defaultReservationData
          ? this.hoursOptions.find(
          (option) =>
            option.value.getTime() ===
            new Date(defaultReservationData.startDate).getTime()
        ) || this.hoursOptions[0]
          : this.hoursOptions[0];
        if (this.hoursOptions.length === 0) {
          if (Math.abs(differenceInDays(toWarsawSlot(reservationDate, 0), toWarsawSlot(new Date(), 0))) > SEARCH_DAYS_AHEAD) {
            this.reservationsNotActive = true;
            return;
          }
          this.prepareReservationsForDay(
            addDays(reservationDate, 1),
            openingHours,
            defaultClientData
          );
          return;
        } else if (!selectedHoursOption) {
          selectedHoursOption = this.hoursOptions[0];
        }
        this.reservationsService.calculateNotAvailableTables(
          this.reservationTables,
          selectedHoursOption.value
        );
        const initialGuestsAmount = this.admin
          ? 0
          : (defaultReservationData?.guestsAmount as number | undefined) || 2;
        this.reservationForm = new FormGroup(
          {
            dateDay: new FormControl(selectedDate.value, Validators.required),
            startDate: new FormControl(
              selectedHoursOption.value,
              Validators.required
            ),
            guestsAmount: new FormControl(
              this.admin
                ? { value: 0, disabled: true }
                : initialGuestsAmount,
              [Validators.required]
            ),
            tables: new FormControl(
              defaultReservationData?.tables || [],
              this.admin ? Validators.required : null
            ),
            firstName: new FormControl(
              defaultClientData.firstName,
              Validators.required
            ),
            surname: new FormControl(
              defaultClientData.surname,
              Validators.required
            ),
            email: new FormControl(
              defaultClientData.email || '',
              this.admin
                ? [Validators.email]
                : [Validators.required, Validators.email]
            ),
            phoneNumber: new FormControl(defaultClientData.phoneNumber, [
              Validators.required,
              Validators.pattern('^[0-9 ]*$'),
              CustomValidators.phoneMinLength(9),
              CustomValidators.startWithValidator]),
            code: new FormControl(defaultClientData.code || '+48', [Validators.required]),
            marketingConsent: new FormControl(
              !!defaultClientData.marketingConsent
            ),
            termsAccepted: new FormControl(
              false,
              this.admin ? [] : [Validators.requiredTrue]
            ),
            endDate: new FormControl(
              addHours(selectedHoursOption.value, this.getAddHours(selectedHoursOption.value)),
              Validators.required
            ),
            vehiclesNumber: new FormControl(0),
            comment: new FormControl(defaultReservationData?.comment || ''),
          },
          [!this.admin ? this.validateGuestAmount : () => null]
        );
        this.isHasGap();
        if (defaultClientData.phoneNumber) {
          this.reservationForm.get('phoneNumber')?.markAllAsTouched()
        }
        this.reservationForm.controls['code'].setValue(defaultClientData.code ? defaultClientData.code : '+48');
        defaultReservationData?.tables.map((table: Table) =>
          this.reservationsService.tableClicked(table)
        );
        let dateDayFormSub = this.reservationForm.controls[
          'dateDay'
          ].valueChanges.subscribe((dateDay) => {
          this.reservationsService
            .getReservationTables(toWarsawSlot(dateDay, 0))
            .subscribe((reservationTables: ReservationTables[]) => {
              // Wykluczamy status 2 (gość nie przybył). Status 4 (gość wyszedł)
              // liczy się dalej, ale z krótszym końcem (left_at) + 30 min bufora.
              reservationTables = reservationTables.filter(reservation => reservation.status !== 2);
              this.reservationTables = reservationTables;
              this.setGardenOpenForDay(dateDay);
              this.hoursOptions =
                this.getHours(dateDay, openingHours);
              // Konsumujemy jednorazowo — także gdy dzień nie ma godzin, żeby
              // nie zadziałało przy kolejnej, ręcznej zmianie dnia.
              const desiredStart = this.pendingStartDate;
              this.pendingStartDate = null;
              if (this.hoursOptions.length > 0 && this.hoursOptions[0].value) {
                // Domyślnie pierwsza godzina otwarcia, ale jeśli klient kliknął
                // „Wybierz ten termin", ustawiamy dokładnie sugerowaną godzinę
                // (o ile jest dostępna w opcjach dla tego dnia).
                let startToSet = this.hoursOptions[0].value;
                if (desiredStart) {
                  const match = this.hoursOptions.find(
                    (o) =>
                      o.value && o.value.getTime() === desiredStart.getTime()
                  );
                  if (match) {
                    startToSet = match.value;
                  }
                }
                this.reservationForm.patchValue({
                  startDate: startToSet,
                });
              }
              if (!this.admin) {
                this.runAvailabilityCheck();
              }
              // Gdy dzień nie ma godzin, startDate się nie zmienia i powyższa
              // ścieżka nie odpali auto-doboru — wołamy go tu dla pewności.
              this.runAdminAutoAssign();
            });
        });
        let startDateFormSub = this.reservationForm.controls[
          'startDate'
          ].valueChanges.subscribe((startDate: Date) => {
          const addHour = this.getAddHours(startDate);
          let endDate = startDate;
          if (addHour === 1.5) {
            endDate = addHours(startDate, 1);
            endDate = addMinutes(endDate, 30);
          } else {
            endDate = addHours(startDate, addHour)
          }
          this.reservationForm.patchValue({
            endDate,
          });
          this.reservationsService.calculateNotAvailableTables(
            this.reservationTables,
            startDate
          );
          if (!this.admin) {
            this.runAvailabilityCheck();
          }
          // Po calculateNotAvailableTables (woła unselectAllTables i czyści
          // zaznaczenie) w trybie auto dobieramy stolik dla nowej godziny.
          this.runAdminAutoAssign();
        });
        let guestsAmountSub = this.reservationForm.controls[
          'guestsAmount'
          ].valueChanges.subscribe(() => {
          if (!this.admin) {
            this.runAvailabilityCheck();
          }
          this.runAdminAutoAssign();
        });
        let tablesFormSub = this.reservationForm.controls[
          'tables'
          ].valueChanges.subscribe((tables: Table[]) => {
          // Tylko tryb ręczny: liczba gości wynika z pojemności klikniętych
          // stolików. W trybie auto jest odwrotnie — to liczba gości wpisana
          // przez kelnera steruje doborem stolików, więc jej nie nadpisujemy.
          if (this.admin && this.adminTableMode === 'manual') {
            this.reservationForm.patchValue(
              {
                guestsAmount: tables.reduce(
                  (prev, curr) => curr.maxGuests + prev,
                  0
                ),
              },
              { emitEvent: false }
            );
          }
        });
        let vehiclesNumberSub = this.reservationForm.controls[
          'vehiclesNumber'
          ].valueChanges.subscribe((vehiclesNumber: number) => {
          // if (vehiclesNumber > 0) {
          //   this.reservationForm.controls['email'].setValidators([
          //     Validators.required,
          //     Validators.email,
          //   ]);
          //   this.reservationForm.controls['email'].updateValueAndValidity();
          // } else {
          //   this.reservationForm.controls['email'].clearValidators();
          //   this.reservationForm.controls['email'].updateValueAndValidity();
          // }
        });
        let choosenTablesSub =
        this.reservationsService.$choosenTables.subscribe((choosenTables) => {
          if (!this.admin) {
            return;
          }
          let tables = choosenTables;
          if (this.isRestaurant) {
            const table_number_10_choosen = !!choosenTables.find(table => table.id === 11);
            const table_number_11_choosen = !!choosenTables.find(table => table.id === 12);
            const formTables = [...this.reservationForm.get('tables')?.value];
            const table_number_10_choosen_form = !!formTables.find(table => table.id === 11);
            const table_number_11_choosen_form = !!formTables.find(table => table.id === 12);

            // hotFix - refactor
            if(this.st1) {
              clearTimeout(this.st1);
            }

            if(this.st2) {
              clearTimeout(this.st2);
            }

            if(this.st3) {
              clearTimeout(this.st3);
            }

            if(this.st4) {
              clearTimeout(this.st4);
            }

            if (table_number_10_choosen && !table_number_11_choosen_form) {
              this.st1 = setTimeout(() => {
                const doc = document.getElementById('table-' + 12);
                doc?.click();
              }, 10);
            }
            if (table_number_11_choosen && !table_number_10_choosen_form) {
              this.st2 = setTimeout(() => {
                const doc = document.getElementById('table-' + 11);
                doc?.click();
              }, 10);
            }
            if ((!table_number_11_choosen && table_number_11_choosen_form)) {
              tables = tables.filter(table => table.id !== 11 && table.id !== 12);

              this.st3 = setTimeout(() => {
                const doc = document.getElementById('table-' + 11);
                doc?.click();
              }, 10);
            }
            if ((!table_number_10_choosen && table_number_10_choosen_form)) {
              tables = tables.filter(table => table.id !== 11 && table.id !== 12);

              this.st4 =setTimeout(() => {
                const doc = document.getElementById('table-' + 12);
                doc?.click();
              }, 10);
            }



            const table_number_1_choosen = !!choosenTables.find(table => table.id === 2);
            const table_number_2_choosen = !!choosenTables.find(table => table.id === 3);
            const formTables1_2 = [...this.reservationForm.get('tables')?.value];
            const table_number_1_choosen_form = !!formTables1_2.find(table => table.id === 2);
            const table_number_2_choosen_form = !!formTables1_2.find(table => table.id === 3);

            // hotFix - refactor
            if(this.st5) {
              clearTimeout(this.st5);
            }

            if(this.st6) {
              clearTimeout(this.st6);
            }

            if(this.st7) {
              clearTimeout(this.st7);
            }

            if(this.st8) {
              clearTimeout(this.st8);
            }

            if (table_number_1_choosen && !table_number_2_choosen_form) {
              this.st5 = setTimeout(() => {
                const doc = document.getElementById('table-' + 3);
                doc?.click();
              }, 10);
            }
            if (table_number_2_choosen && !table_number_1_choosen_form) {
              this.st6 = setTimeout(() => {
                const doc = document.getElementById('table-' + 2);
                doc?.click();
              }, 10);
            }
            if ((!table_number_2_choosen && table_number_2_choosen_form)) {
              tables = tables.filter(table => table.id !== 2 && table.id !== 3);

              this.st7 = setTimeout(() => {
                const doc = document.getElementById('table-' + 2);
                doc?.click();
              }, 10);
            }
            if ((!table_number_1_choosen && table_number_1_choosen_form)) {
              tables = tables.filter(table => table.id !== 2 && table.id !== 3);

              this.st8 =setTimeout(() => {
                const doc = document.getElementById('table-' + 3);
                doc?.click();
              }, 10);
            }



            const table_number_17_choosen = !!choosenTables.find(table => table.id === 18);
            const table_number_18_choosen = !!choosenTables.find(table => table.id === 19);
            const formTables17_18 = [...this.reservationForm.get('tables')?.value];
            const table_number_17_choosen_form = !!formTables17_18.find(table => table.id === 18);
            const table_number_18_choosen_form = !!formTables17_18.find(table => table.id === 19);

            // hotFix - refactor
            if(this.st9) {
              clearTimeout(this.st9);
            }

            if(this.st10) {
              clearTimeout(this.st10);
            }

            if(this.st11) {
              clearTimeout(this.st11);
            }

            if(this.st12) {
              clearTimeout(this.st12);
            }

            if (table_number_17_choosen && !table_number_18_choosen_form) {
              this.st9 = setTimeout(() => {
                const doc = document.getElementById('table-' + 19);
                doc?.click();
              }, 10);
            }
            if (table_number_18_choosen && !table_number_17_choosen_form) {
              this.st10 = setTimeout(() => {
                const doc = document.getElementById('table-' + 18);
                doc?.click();
              }, 10);
            }
            if ((!table_number_18_choosen && table_number_18_choosen_form)) {
              tables = tables.filter(table => table.id !== 18 && table.id !== 19);

              this.st11 = setTimeout(() => {
                const doc = document.getElementById('table-' + 18);
                doc?.click();
              }, 10);
            }
            if ((!table_number_17_choosen && table_number_17_choosen_form)) {
              tables = tables.filter(table => table.id !== 18 && table.id !== 19);

              this.st12 =setTimeout(() => {
                const doc = document.getElementById('table-' + 19);
                doc?.click();
              }, 10);
            }

          }
          this.reservationForm.patchValue({tables: tables});
        });
        let storeDataOnChanges = this.reservationForm.valueChanges.subscribe(
          (res) => {
            const clientSavedData = {
              firstName: this.reservationForm.controls['firstName'].value,
              surname: this.reservationForm.controls['surname'].value,
              phoneNumber: this.reservationForm.controls['phoneNumber'].value,
              comment: this.reservationForm.controls['comment'].value,
              code: this.reservationForm.controls['code'].value,
              email: this.reservationForm.controls['email'].value,
              marketingConsent: this.reservationForm.controls['marketingConsent'].value,
            };
            localStorage.setItem(
              this.CLIENT_SAVED_DATA,
              JSON.stringify(clientSavedData)
            );
            localStorage.setItem(
              this.RESERVATION_SAVED_DATA,
              JSON.stringify(this.reservationForm.getRawValue())
            );
          }
        );
        this.subscriptions.push(
          dateDayFormSub,
          startDateFormSub,
          guestsAmountSub,
          tablesFormSub,
          choosenTablesSub,
          vehiclesNumberSub,
          storeDataOnChanges
        );

        if (!this.admin) {
          this.runAvailabilityCheck();
        }
      });

    if (this.reservationForm && this.reservationForm.controls && this.reservationForm.controls['code']) {
      this.filteredCodeNumber = this.reservationForm.controls['code'].valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    }
  }

  private getDate(reservationDate: Date) {
    return (
      this.daysOptions.find((daysOption) =>
        isSameDayInWarsaw(daysOption.value, reservationDate)
      ) || this.daysOptions[0]
    );
  }

  ngOnChanges(): void {
    if (this.reservation) {
      this.reservationForm.patchValue({
        dateDay: this.getDate(this.reservation.startDate).value,
        startDate: this.reservation.startDate,
        guestsAmount: this.reservation.guestNumber,
        tables: this.reservation.tables,
        firstName: this.reservation.firstName,
        surname: this.reservation.surname,
        email: this.reservation.email,
        phoneNumber: this.reservation.phoneNumber,
        endDate: this.reservation.endDate,
        vehiclesNumber: this.reservation.vehiclesNumber,
        comment: this.reservation.comment,
      });
    }
  }

  previousStep(): void {
    this.reservationStep--;
    this.stepChanged.emit(this.reservationStep);
  }

  nextStep(): void {
    this.reservationStep++;
    this.stepChanged.emit(this.reservationStep);
  }

  back() {
    this.backToChange.emit();
  }

  sendReservation(): void {
    if (this.reservationForm && this.reservationForm.valid) {
      const reservationRequest: ReservationWithTablesRequest = {
        tables: this.reservationForm.controls['tables'].value,
        firstName: this.reservationForm.controls['firstName'].value,
        surname: this.reservationForm.controls['surname'].value,
        email: this.reservationForm.controls['email'].value,
        phoneNumber: this.reservationForm.controls['code'].value + this.reservationForm.controls['phoneNumber'].value,
        startDate: this.reservationForm.controls['startDate'].value,
        endDate: this.getEndDate(this.reservationForm.controls['startDate'].value, this.reservationForm.controls['endDate'].value),
        // Number(): w trybie auto kelner wpisuje liczbę gości ręcznie, więc
        // z inputa mogłaby przyjść wartość tekstowa.
        guestNumber: Number(this.reservationForm.controls['guestsAmount'].value),
        vehiclesNumber: this.reservationForm.controls['vehiclesNumber'].value,
        comment: this.reservationForm.controls['comment'].value,
        isGarden: this.admin ? !this.isRestaurant : this.availabilityIsGarden,
        marketingConsent: !!this.reservationForm.controls['marketingConsent']?.value,
      };
      this.sendingReservation = true;
      this.reservationsService
        .sendReservationRequest(reservationRequest)
        .pipe(
          finalize(() => {
            setTimeout(() => {
              //Slow down for the experience
              const clientSavedData = {
                firstName: this.reservationForm.controls['firstName'].value,
                surname: this.reservationForm.controls['surname'].value,
                phoneNumber: this.reservationForm.controls['phoneNumber'].value,
                code: this.reservationForm.controls['code'].value,
                email: this.reservationForm.controls['email'].value,
                marketingConsent: this.reservationForm.controls['marketingConsent'].value,
              };
              localStorage.setItem(
                this.CLIENT_SAVED_DATA,
                JSON.stringify(clientSavedData)
              );
              localStorage.removeItem(this.RESERVATION_SAVED_DATA);
              this.sendingReservation = false;
            }, 1500);
          })
        )
        .subscribe(() => {
            this.nextStep();
          },
          () => {
            this.snackBar.open('Nie udało się dokonać rezerwacji. Miejsca zostały już zajęte',
              '', {panelClass: 'snack-bar-error'});
          }
        );
    }
  }

  dateCompareFunc(d1: Date, d2: Date): boolean {
    return d1.getTime() === d2.getTime();
  }

  /** Data rezerwacji w strefie Warszawa (dd.MM.yyyy) do podsumowania. */
  formatReservationDateWarsaw(date: Date): string {
    return date ? formatDateWarsaw(date) : '';
  }

  /** Godzina rezerwacji w strefie Warszawa (HH:mm) do podsumowania. */
  formatReservationTimeWarsaw(date: Date): string {
    return date ? formatTimeWarsaw(date) : '';
  }

  validateGuestAmount = (control: AbstractControl): ValidationErrors | null => {
    const guestsAmount = (control as any).get('guestsAmount').value;
    if (guestsAmount < 1)
      return {
        guestsAmount: {
          min: true,
        },
      };
    if (guestsAmount > 8)
      return {
        guestsAmount: {
          max: true,
        },
      };
    return null;
  };

  onSelect(event: any) {
    this.reservationForm.controls['code'].setValue(event.option.value);
  }

  /** Format wartości w autocomplete – pokazuje kod i kraj. */
  displayPhoneCode = (value: string): string => {
    if (!value) {
      return '';
    }
    const found = this.phoneCodes.find((c) => c.code === value);
    return found ? `${found.code} ${found.country}` : value;
  };

  /**
   * Lista godzin startu dla danego dnia.
   *
   * UWAGA: ta metoda jest celowo BEZ efektów ubocznych. Wcześniej ustawiała
   * `this.isGardenOpen`, przez co wyszukiwanie kolejnego wolnego terminu
   * (iteruje po kolejnych dniach) zostawiało w tym polu flagę OSTATNIEGO
   * sprawdzonego dnia zamiast dnia wybranego przez klienta — i ogródek bywał
   * wtedy błędnie uznawany za zamknięty. Flagę ustawiamy jawnie w miejscach,
   * gdzie faktycznie zmienia się wybrany dzień (patrz setGardenOpenForDay).
   */
  getHours(dateDay: Date, openingHours: OpeningHour[], minTimeBeforeEnd = 120) {
    const dateDayNorm = toWarsawSlot(dateDay, 0);
    const specialDay = this.specialDays.find(day => isSameDayInWarsaw(new Date(day.specialDate), dateDayNorm));
    if (specialDay) {
      return this.reservationsService.prepareHoursOptionsForSpecialDay(specialDay,
        addHours(new Date(), this.getBufor()),
        minTimeBeforeEnd
      )
    } else {
      return this.reservationsService.prepareHoursOptions(
        dateDayNorm,
        openingHours,
        addHours(new Date(), this.getBufor()),
        minTimeBeforeEnd
      );
    }
  }

  /** Ustawia flagę „ogródek otwarty" dla aktualnie WYBRANEGO dnia. */
  private setGardenOpenForDay(dateDay: Date): void {
    this.isGardenOpen = this.getDayInfoForDate(
      toWarsawSlot(dateDay, 0)
    ).isGardenOpen;
  }

  /** Przełączenie trybu doboru stolika przez kelnera (auto / ręcznie). */
  setAdminTableMode(mode: 'auto' | 'manual'): void {
    this.adminTableMode = mode;
    const guestsControl = this.reservationForm.get('guestsAmount');
    if (mode === 'auto') {
      // W trybie auto to kelner wpisuje liczbę gości i ona steruje doborem.
      guestsControl?.enable({ emitEvent: false });
      // Czyścimy zaznaczenie z rzutu sali, żeby serwis nie trzymał stolików
      // klikniętych wcześniej ręcznie — dobór i tak ustawi je od nowa poniżej.
      this.reservationsService.unselectAllTables();
      this.runAdminAutoAssign();
    } else {
      // W trybie ręcznym liczba gości wynika z pojemności klikniętych stolików.
      guestsControl?.disable({ emitEvent: false });
      this.adminAutoAssignError = false;
      this.reservationsService.unselectAllTables();
      this.reservationForm.patchValue({ tables: [] }, { emitEvent: false });
    }
  }

  /**
   * Kelner w trybie automatycznym: system dobiera stolik(i) dla wpisanej liczby
   * gości i wybranej godziny — wg tych samych kombinacji co ścieżka klienta.
   *
   * Wywoływane po każdej zmianie dnia/godziny/liczby gości. Ważne: robimy to PO
   * calculateNotAvailableTables, bo ono woła unselectAllTables() i czyści
   * zaznaczenie. Stoliki ustawiamy z emitEvent:false, żeby nie odpalić
   * przeliczania liczby gości z pojemności stolików.
   */
  private runAdminAutoAssign(): void {
    if (!this.admin || this.adminTableMode !== 'auto' || !this.reservationForm) {
      return;
    }
    const startDate: Date = this.reservationForm.controls['startDate'].value;
    const guests = Number(this.reservationForm.controls['guestsAmount'].value);
    if (!startDate || !guests || guests < 1) {
      this.reservationForm.patchValue({ tables: [] }, { emitEvent: false });
      this.adminAutoAssignError = false;
      return;
    }
    let slot: SlotAvailability | null = null;
    if (this.isRestaurant) {
      slot = this.autoAssignRestaurantTables(
        startDate,
        guests,
        this.reservationTables
      );
    } else if (this.isGardenOpen) {
      slot = this.autoAssignGardenTables(
        startDate,
        guests,
        this.reservationTables
      );
    }
    this.reservationForm.patchValue(
      { tables: slot ? slot.tables : [] },
      { emitEvent: false }
    );
    this.adminAutoAssignError = !slot;
  }

  /** Numery stolików dobranych automatycznie – do komunikatu dla kelnera. */
  getSelectedTableNumbers(): string {
    const tables: Table[] = this.reservationForm?.get('tables')?.value || [];
    return tables.map((table) => table.tableNumber).join(', ');
  }

  getAddHours(hours: any) {
    // Rezerwacja trwa 2h zarówno w lokalu, jak i w ogródku (wcześniej ogródek
    // miał 3h – uznane za błąd). Fallback skraca do 1.5h/1h tylko pod koniec dnia.
    if (!this.endHoursOptions || this.endHoursOptions.length === 0) {
      return 2;
    }
    const lastEndHours = this.endHoursOptions[this.endHoursOptions.length - 1].value;
    let reservationEndHours = addHours(hours, 2)
    if (lastEndHours >= reservationEndHours) {
      return 2;
    } else {
      reservationEndHours = addHours(hours, 1);
      reservationEndHours = addMinutes(reservationEndHours, 30);
      if (lastEndHours >= reservationEndHours) {
        return 1.5;
      } else {
        reservationEndHours = addHours(hours, 1);
        if (lastEndHours >= reservationEndHours) {
          return 1;
        }
      }
    }
    return 2;
  }

  openParkingInfo() {
    this.route.navigate(['/instrukcja-parkingu-kroki']);
  }

  isHasGap() {
    if (!this.admin) {
      this.isHasGapError = false;
      return;
    }
    this.reservationForm.get('tables')?.valueChanges.subscribe(tables => {
      if (tables) {
        const currentTables = tables.map((table: { tableNumber: any; }) => table.tableNumber);
        currentTables.sort();

        const hasGap = (array: number[]) => array.some((element, index) => index > 0 && element !== array[index - 1] + 1);

        const isSubset = (subset: number[], set: number[]) => subset.every(element => set.includes(element));

        const checkGapsAndSetError = (groupTables: number[][]) => {
          this.isHasGapError = !groupTables.some(group => {
            const inGroup = isSubset(currentTables, group);
            return inGroup && !hasGap(currentTables);
          });
        };

        if (this.isRestaurant) {
          checkGapsAndSetError([this.restaurantUpTablesId, this.restaurantDownTablesId]);
        } else {
          checkGapsAndSetError([this.gardenOneLineTablesId, this.gardenTwoLineTablesId, this.gardenThreeLineTablesId]);
        }
      }
    });
  }

  reservationInLocal() {
    this.isRestaurant = true;
    this.tables = this.allTables.filter(table => !table.isGardenOpen);
    // Zmiana lokalizacji = inne kombinacje stolików, więc dobieramy od nowa.
    this.runAdminAutoAssign();
  }

  reservationInGarden() {
    this.isRestaurant = false;
    this.tables = this.allTables.filter(table => table.isGardenOpen);
    this.runAdminAutoAssign();
  }

  /**
   * Bufor czasowy w godzinach – ile godzin "od teraz" musi minąć,
   * zanim można dokonać rezerwacji. Etap 3 wymagań: bufor zniesiony (0).
   */
  getBufor(): number {
    return 0;
  }

  isDateInPast(dateToCheck: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dateToCheck.setHours(0, 0, 0, 0);
    return dateToCheck < today;
  }

  getEndDate(startDate: Date, endDate: Date) {
    const firstDate = new Date(startDate);
    const secondDate = new Date(endDate);
    const normalizedFirstDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate());
    const normalizedSecondDate = new Date(secondDate.getFullYear(), secondDate.getMonth(), secondDate.getDate());
    const differenceInTime = Math.abs(normalizedSecondDate.getTime() - normalizedFirstDate.getTime());
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    if (differenceInDays) {
      return addMinutes(endDate, -1);
    }
    return endDate;
  }

  // -----------------------------------------------------------------------
  // Logika auto-przydzielania stolików oraz wyszukiwania najbliższego wolnego
  // terminu (ścieżka klienta – widok bez rzutu sali).
  // -----------------------------------------------------------------------

  /**
   * Czas trwania rezerwacji w minutach – używane przy sprawdzaniu dostępności
   * stolików. Zarówno lokal, jak i ogródek: 2h (wcześniej ogródek miał 3h).
   */
  private getReservationDurationMinutes(isGarden: boolean): number {
    return 120;
  }

  /**
   * Czy konkretny stolik jest wolny we wskazanym oknie czasowym, uwzględniając
   * istniejące rezerwacje oraz 30-minutowy bufor przerwy po KAŻDEJ rezerwacji.
   *
   * Bufor doliczamy po obu stronach: nie tylko po rezerwacji już istniejącej,
   * ale też po tej właśnie zakładanej — jej goście również potrzebują czasu na
   * opuszczenie stolika. Bez tego dało się „dokleić" nową rezerwację tuż przed
   * istniejącą (np. kończącą się dokładnie o godzinie startu następnej).
   */
  private isTableFreeAt(
    tableId: number,
    startDate: Date,
    durationMinutes: number,
    reservationTables: ReservationTables[]
  ): boolean {
    const newStart = startDate.getTime();
    const newEndWithGap = addMinutes(
      startDate,
      durationMinutes + RESERVATION_GAP_MINUTES
    ).getTime();
    for (const reservation of reservationTables) {
      if (!reservation.reservedTables?.includes(tableId)) {
        continue;
      }
      const resStart = new Date(reservation.startDate).getTime();
      const resEnd = addMinutes(new Date(reservation.endDate), RESERVATION_GAP_MINUTES).getTime();
      if (newStart < resEnd && newEndWithGap > resStart) {
        return false;
      }
    }
    return true;
  }

  /**
   * Zwraca WSZYSTKIE wolne kombinacje w danym oknie czasowym, zachowując
   * kolejność z listy (= priorytet klienta). Wybór spośród nich robi
   * pickBestSpreadCombo (rozpraszanie gości po sali).
   */
  private findFreeCombos(
    combos: number[][],
    isGarden: boolean,
    startDate: Date,
    durationMinutes: number,
    reservationTables: ReservationTables[]
  ): Table[][] {
    const result: Table[][] = [];
    for (const combo of combos) {
      // WAŻNE: kombinacje są zapisane NUMERAMI stolików (table_number), a NIE id.
      // W bazie id != numer (Sala: id = numer + 1; numery 20–27 istnieją podwójnie
      // w Sali i Ogródku), dlatego stoliki wyszukujemy po table_number + fladze
      // ogródka, a dostępność sprawdzamy po realnym id znalezionego stolika.
      const tables = combo
        .map((num) =>
          this.allTables.find(
            (t) => t.tableNumber === num && !!t.isGardenOpen === isGarden
          )
        )
        .filter((t): t is Table => !!t);
      // Pomijamy kombinację, jeśli w danych brakuje któregoś stolika.
      if (tables.length !== combo.length) {
        continue;
      }
      const allFree = tables.every((t) =>
        this.isTableFreeAt(t.id, startDate, durationMinutes, reservationTables)
      );
      if (allFree) {
        result.push(tables);
      }
    }
    return result;
  }

  /** Środek stolika na planie sali (współrzędne + rozmiar z position_x/y). */
  private tableCenter(table: Table): { x: number; y: number } {
    return {
      x: (table.left ?? 0) + (table.width ?? 0) / 2,
      y: (table.top ?? 0) + (table.height ?? 0) / 2,
    };
  }

  /**
   * Środki stolików ZAJĘTYCH w danym oknie czasowym (z buforem) w wybranej
   * lokalizacji. Punkt odniesienia dla rozpraszania — nowy stolik dobieramy jak
   * najdalej od tych punktów, żeby goście nie siedzieli w kupie, gdy sala jest
   * w połowie pusta.
   */
  private getOccupiedCenters(
    startDate: Date,
    durationMinutes: number,
    isGarden: boolean,
    reservationTables: ReservationTables[]
  ): { x: number; y: number }[] {
    return this.allTables
      .filter(
        (t) =>
          !!t.isGardenOpen === isGarden &&
          !this.isTableFreeAt(
            t.id,
            startDate,
            durationMinutes,
            reservationTables
          )
      )
      .map((t) => this.tableCenter(t));
  }

  /**
   * „Rozproszenie" kombinacji = najmniejsza odległość któregokolwiek z jej
   * stolików do najbliższego zajętego stolika. Im większa, tym dalej od tłumu.
   * Brak zajętych → Infinity (sala pusta, decyduje priorytet z listy).
   */
  private comboSpreadScore(
    tables: Table[],
    occupiedCenters: { x: number; y: number }[]
  ): number {
    if (occupiedCenters.length === 0) {
      return Infinity;
    }
    let minDist = Infinity;
    for (const table of tables) {
      const c = this.tableCenter(table);
      for (const o of occupiedCenters) {
        const d = Math.hypot(c.x - o.x, c.y - o.y);
        if (d < minDist) {
          minDist = d;
        }
      }
    }
    return minDist;
  }

  /**
   * Spośród wolnych kombinacji wybiera tę położoną NAJDALEJ od zajętych stolików
   * (największy min-dystans). Remis rozstrzyga kolejność na liście (priorytet
   * klienta), bo iterujemy od początku i podmieniamy tylko przy ostro większym
   * wyniku. Gdy nic nie jest zajęte → pierwsza wg priorytetu.
   */
  private pickBestSpreadCombo(
    freeCombos: Table[][],
    occupiedCenters: { x: number; y: number }[]
  ): Table[] | null {
    if (freeCombos.length === 0) {
      return null;
    }
    if (occupiedCenters.length === 0) {
      return freeCombos[0];
    }
    let best = freeCombos[0];
    let bestScore = this.comboSpreadScore(best, occupiedCenters);
    for (let i = 1; i < freeCombos.length; i++) {
      const score = this.comboSpreadScore(freeCombos[i], occupiedCenters);
      if (score > bestScore) {
        best = freeCombos[i];
        bestScore = score;
      }
    }
    return best;
  }

  /**
   * Zwraca stan „czystych" czwórek dla wybranej lokalizacji: ile ich fizycznie
   * istnieje w danych oraz które są wolne w danym oknie czasowym.
   *
   * WAŻNE: bierzemy pod uwagę TYLKO czwórki, które NIE są jednocześnie stolikami
   * 2-osobowymi (żaden ich stolik nie występuje w kubełku '1-2'). Inaczej licznik
   * byłby zaniżony — fallback dla par odpala się dopiero gdy wszystkie dwójaki są
   * zajęte, a wtedy „wspólne" czwórki (np. 3/4, 6/7, 8/9 w lokalu) i tak są już
   * zajęte przez pary. Czyste czwórki w lokalu: [1,2], [12,13], [14,15], [17,18].
   * Czwórki liczymy per-kombinacja (para stolików = jeden „stolik 4-osobowy").
   */
  private getFoursStatus(
    isGarden: boolean,
    startDate: Date,
    durationMinutes: number,
    reservationTables: ReservationTables[]
  ): { total: number; free: Table[][] } {
    const source = isGarden ? GARDEN_COMBOS : RESTAURANT_COMBOS;
    const combos = source['3-4'] || [];
    // Numery stolików, które są (współ)dzielone ze stolikami 2-osobowymi.
    const twoPersonNumbers = new Set<number>(
      (source['1-2'] || []).flat()
    );
    const free: Table[][] = [];
    let total = 0;
    for (const combo of combos) {
      // Pomijamy czwórki, które są jednocześnie stolikami 2-osobowymi.
      if (combo.some((num) => twoPersonNumbers.has(num))) {
        continue;
      }
      const tables = combo
        .map((num) =>
          this.allTables.find(
            (t) => t.tableNumber === num && !!t.isGardenOpen === isGarden
          )
        )
        .filter((t): t is Table => !!t);
      // Pomijamy czwórkę, jeśli w danych brakuje któregoś stolika.
      if (tables.length !== combo.length) {
        continue;
      }
      total++;
      const allFree = tables.every((t) =>
        this.isTableFreeAt(t.id, startDate, durationMinutes, reservationTables)
      );
      if (allFree) {
        free.push(tables);
      }
    }
    return { total, free };
  }

  /**
   * Fallback dla rezerwacji 2-osobowych: gdy wszystkie stoliki 2-osobowe są zajęte,
   * pozwalamy posadzić parę przy czwórce — ale tylko dopóki WIĘCEJ NIŻ połowa
   * czwórek jest wolna (reguła „50% czwórek").
   *
   * UWAGA: dane dostępności nie zawierają liczby osób istniejących rezerwacji,
   * więc jest to przybliżenie (proxy) — nie rozróżniamy czwórek zajętych przez
   * pary od tych zajętych przez większe grupy. Dzięki żywemu przeliczaniu stanu
   * przy każdej rezerwacji efekt jest bliski „max ~50% czwórek zajętych przez pary".
   * Przykład: przy 4 wolnych czwórkach pozwoli zająć 2 z nich dla par.
   */
  private assignTwoOnFourFallback(
    isGarden: boolean,
    startDate: Date,
    durationMinutes: number,
    reservationTables: ReservationTables[],
    occupiedCenters: { x: number; y: number }[]
  ): Table[] | null {
    const { total, free } = this.getFoursStatus(
      isGarden,
      startDate,
      durationMinutes,
      reservationTables
    );
    if (total === 0 || free.length === 0) {
      return null;
    }
    // Reguła: pary mogą zająć maksymalnie 50% czwórek (udział zajętych przez pary
    // <= 50%, czyli max floor(total/2)). Przy nieparzystej liczbie zaokrąglamy w dół.
    // Warunek dopuszczenia kolejnej pary: liczba wolnych czwórek > ceil(total/2).
    // Przykłady: 4 czwórki -> max 2 pary; 7 czwórek -> max 3 pary.
    if (free.length <= Math.ceil(total / 2)) {
      return null;
    }
    // Spośród dopuszczonych wolnych czwórek — najdalsza od zajętych.
    return this.pickBestSpreadCombo(free, occupiedCenters);
  }

  private autoAssignRestaurantTables(
    startDate: Date,
    guests: number,
    reservationTables: ReservationTables[]
  ): SlotAvailability | null {
    return this.autoAssignTables(false, startDate, guests, reservationTables);
  }

  private autoAssignGardenTables(
    startDate: Date,
    guests: number,
    reservationTables: ReservationTables[]
  ): SlotAvailability | null {
    return this.autoAssignTables(true, startDate, guests, reservationTables);
  }

  /**
   * Automatyczny dobór stolików dla wybranej lokalizacji i godziny, wg listy
   * dozwolonych kombinacji klienta. Spośród WOLNYCH kombinacji wybieramy tę
   * najdalej od stolików już zajętych o tej porze — żeby rozpraszać gości po
   * sali, a nie sadzać ich w jednym rogu, gdy reszta stoi pusta.
   *
   * Reguły biznesowe zachowane: dla pary najpierw dedykowane dwuosobowe, potem
   * „podwójne" pary czwórek, a na końcu para przy czwórce (reguła 50% czwórek).
   * Rozpraszanie działa WEWNĄTRZ każdego z tych tierów, nie ponad nimi.
   */
  private autoAssignTables(
    isGarden: boolean,
    startDate: Date,
    guests: number,
    reservationTables: ReservationTables[]
  ): SlotAvailability | null {
    const bucket = getCapacityBucket(guests);
    const source = isGarden ? GARDEN_COMBOS : RESTAURANT_COMBOS;
    const combos = bucket ? source[bucket] : null;
    if (!combos || combos.length === 0) {
      return null;
    }
    const durationMinutes = this.getReservationDurationMinutes(isGarden);
    const occupiedCenters = this.getOccupiedCenters(
      startDate,
      durationMinutes,
      isGarden,
      reservationTables
    );

    if (bucket === '1-2') {
      // Tier 1: dedykowane dwuosobowe (pojedyncze stoliki na liście '1-2').
      const dedicated = combos.filter((combo) => combo.length === 1);
      const dedicatedPick = this.pickBestSpreadCombo(
        this.findFreeCombos(
          dedicated,
          isGarden,
          startDate,
          durationMinutes,
          reservationTables
        ),
        occupiedCenters
      );
      if (dedicatedPick) {
        return { tables: dedicatedPick, isGarden };
      }
      // Tier 2: „podwójne" pary czwórek dopuszczone dla pary (np. 3/4, 8/9).
      const sharedPairs = combos.filter((combo) => combo.length > 1);
      const sharedPick = this.pickBestSpreadCombo(
        this.findFreeCombos(
          sharedPairs,
          isGarden,
          startDate,
          durationMinutes,
          reservationTables
        ),
        occupiedCenters
      );
      if (sharedPick) {
        return { tables: sharedPick, isGarden };
      }
      // Tier 3: wszystkie dwuosobowe zajęte — para przy czwórce (reguła 50%).
      const fallback = this.assignTwoOnFourFallback(
        isGarden,
        startDate,
        durationMinutes,
        reservationTables,
        occupiedCenters
      );
      return fallback ? { tables: fallback, isGarden } : null;
    }

    const picked = this.pickBestSpreadCombo(
      this.findFreeCombos(
        combos,
        isGarden,
        startDate,
        durationMinutes,
        reservationTables
      ),
      occupiedCenters
    );
    return picked ? { tables: picked, isGarden } : null;
  }

  /**
   * Uruchamiana po każdej zmianie daty/godziny/liczby osób.
   * Sprawdza dostępność OSOBNO dla lokalu i ogródka, dzięki czemu klient
   * może wybrać preferowane miejsce, jeśli obie opcje są wolne.
   * Gdy ani lokal ani ogródek nie ma miejsc – pyta backend o najbliższy wolny termin.
   */
  private runAvailabilityCheck(): void {
    if (this.admin || !this.reservationForm) {
      return;
    }
    const guests: number = this.reservationForm.controls['guestsAmount'].value;
    const startDate: Date = this.reservationForm.controls['startDate'].value;
    if (!guests || !startDate) {
      return;
    }
    // Anuluj poprzednie wyszukiwanie – nieaktualne dane.
    if (this.nextSlotSearchSubscription) {
      this.nextSlotSearchSubscription.unsubscribe();
      this.nextSlotSearchSubscription = null;
    }
    this.availabilityState = 'searching';
    this.nextAvailableSlot = null;

    const tables = this.reservationTables || [];
    // Miejsce wybrane na ekranie startowym (Lokal/Ogródek = this.isRestaurant)
    // jest wiążące — klient NIE wybiera ponownie. Dostępność sprawdzamy więc
    // wyłącznie dla wybranej lokalizacji.
    const wantsGarden = !this.isRestaurant;
    this.gardenAllowedToday = this.isGardenSeason && this.isGardenOpen;
    if (wantsGarden) {
      this.gardenSlot = this.gardenAllowedToday
        ? this.autoAssignGardenTables(startDate, guests, tables)
        : null;
      this.restaurantSlot = null;
    } else {
      this.restaurantSlot = this.autoAssignRestaurantTables(
        startDate,
        guests,
        tables
      );
      this.gardenSlot = null;
    }

    const chosenSlot = wantsGarden ? this.gardenSlot : this.restaurantSlot;
    if (chosenSlot) {
      this.availabilityState = 'available';
      this.selectLocation(wantsGarden);
      return;
    }

    // Brak miejsc w wybranej lokalizacji – szukamy najbliższego wolnego terminu
    // w TEJ SAMEJ lokalizacji.
    this.availabilityState = 'not_available';
    this.nextSlotSearchSubscription = this.findNextAvailableSlot(
      startDate,
      guests,
      wantsGarden
    ).subscribe((next) => {
      if (next) {
        this.nextAvailableSlot = next;
      } else {
        this.availabilityState = 'no_availability_in_period';
      }
    });
  }

  /**
   * Wywoływane gdy klient klika kafelek Lokal/Ogródek lub gdy system
   * dobiera lokalizację automatycznie. Ustawia stoliki + endDate w formularzu.
   */
  selectLocation(isGarden: boolean): void {
    const slot = isGarden ? this.gardenSlot : this.restaurantSlot;
    if (!slot) {
      return;
    }
    this.availabilityIsGarden = isGarden;
    this.isRestaurant = !isGarden;
    this.reservationForm.patchValue(
      { tables: slot.tables },
      { emitEvent: false }
    );
    const startDate: Date = this.reservationForm.controls['startDate'].value;
    if (startDate) {
      const endDate = addMinutes(
        startDate,
        this.getReservationDurationMinutes(isGarden)
      );
      this.reservationForm.patchValue({ endDate }, { emitEvent: false });
    }
  }

  /** Czy klient ma rzeczywisty wybór między lokalem a ogródkiem. */
  get hasLocationChoice(): boolean {
    return !!this.restaurantSlot && !!this.gardenSlot;
  }

  /**
   * Iteracyjnie sprawdza kolejne dni i kolejne godziny otwarcia, aż znajdzie
   * pierwszy slot z dostępnym stolikiem dla podanej liczby osób.
   */
  private findNextAvailableSlot(
    afterStart: Date,
    guests: number,
    wantsGarden: boolean
  ): Observable<NextAvailableSlot | null> {
    const checkDay = (
      dayIndex: number
    ): Observable<NextAvailableSlot | null> => {
      if (dayIndex >= this.daysOptions.length) {
        return of(null);
      }
      const dayValue = this.daysOptions[dayIndex].value;
      return this.reservationsService
        .getReservationTables(toWarsawSlot(dayValue, 0))
        .pipe(
          switchMap((reservationTables) => {
            // Wykluczamy status 2 (gość nie przybył). Status 4 (gość wyszedł)
            // liczy się dalej, ale z krótszym końcem (left_at) + 30 min bufora.
            const filtered = reservationTables.filter(
              (r) => r.status !== 2
            );
            const isFirstDay = dayIndex === 0;
            const hours = this.getHours(dayValue, this.openingHours);
            const startThreshold = afterStart.getTime();
            for (const option of hours) {
              if (isFirstDay && option.value.getTime() <= startThreshold) {
                continue;
              }
              const dayInfo = this.getDayInfoForDate(dayValue);
              // Szukamy kolejnego terminu wyłącznie w lokalizacji wybranej
              // przez klienta na ekranie startowym.
              let slot: SlotAvailability | null = null;
              if (wantsGarden) {
                if (this.isGardenSeason && dayInfo.isGardenOpen) {
                  slot = this.autoAssignGardenTables(
                    option.value,
                    guests,
                    filtered
                  );
                }
              } else {
                slot = this.autoAssignRestaurantTables(
                  option.value,
                  guests,
                  filtered
                );
              }
              if (slot) {
                return of<NextAvailableSlot | null>({
                  date: dayValue,
                  startDate: option.value,
                  isGarden: slot.isGarden,
                  tables: slot.tables,
                });
              }
            }
            return checkDay(dayIndex + 1);
          })
        );
    };

    const startIndex = Math.max(
      0,
      this.daysOptions.findIndex((opt) =>
        isSameDayInWarsaw(opt.value, afterStart)
      )
    );
    return checkDay(startIndex);
  }

  /**
   * Zwraca informację o tym, czy w danym dniu ogródek jest otwarty
   * (na podstawie opening_hours lub special_days).
   */
  private getDayInfoForDate(date: Date): { isGardenOpen: boolean } {
    const specialDay = this.specialDays.find((d) =>
      isSameDayInWarsaw(new Date(d.specialDate), date)
    );
    if (specialDay) {
      return { isGardenOpen: !!specialDay.isGardenOpen };
    }
    const opening = this.openingHours.find(
      (oh) => oh.order === getISODayInWarsaw(date)
    );
    return { isGardenOpen: !!opening?.isGardenOpen };
  }

  /**
   * Czy sugerowany termin jest WCZEŚNIEJSZY niż wybrany przez klienta.
   * Używane do rozdzielenia komunikatu: dla terminów wcześniejszych pokazujemy
   * "Proponujemy wcześniejszy termin", a dla późniejszych "Najbliższy dostępny
   * termin". Porównujemy pełny moment (data + godzina), więc np. jutro 15:00
   * względem dziś 17:00 jest traktowane jako termin późniejszy.
   */
  suggestedSlotIsEarlier(): boolean {
    if (!this.nextAvailableSlot || !this.reservationForm) {
      return false;
    }
    const chosen: Date = this.reservationForm.controls['startDate'].value;
    if (!chosen) {
      return false;
    }
    return this.nextAvailableSlot.startDate.getTime() < chosen.getTime();
  }

  /** Zastosuj sugerowany termin – ustaw datę i godzinę w formularzu. */
  applyNextAvailableSlot(): void {
    if (!this.nextAvailableSlot) {
      return;
    }
    const slot = this.nextAvailableSlot;
    // Zapamiętujemy godzinę i zmieniamy dzień. Zmiana dnia odpala async
    // przebudowę listy godzin, która ustawi startDate na pendingStartDate
    // (patrz subskrypcja dateDay). setTimeout tu nie działał, bo async HTTP
    // kończył się PO nim i nadpisywał godzinę pierwszą godziną otwarcia.
    this.pendingStartDate = slot.startDate;
    this.reservationForm.patchValue({ dateDay: slot.date });
  }

  /** Etykieta dla dnia w komunikacie: "dziś", "jutro", lub data dd.MM.yyyy. */
  getDayLabelForMessage(date: Date): { key: 'today' | 'tomorrow' | 'date'; value: string } {
    const today = toWarsawSlot(new Date(), 0);
    const tomorrow = toWarsawSlot(addDays(new Date(), 1), 0);
    const target = toWarsawSlot(date, 0);
    if (isSameDayInWarsaw(target, today)) {
      return { key: 'today', value: '' };
    }
    if (isSameDayInWarsaw(target, tomorrow)) {
      return { key: 'tomorrow', value: '' };
    }
    return { key: 'date', value: formatDateWarsaw(date) };
  }

}

export class CustomValidators {
  static startWithValidator(control: AbstractControl) {
    const phoneNumberControl = control.parent?.get('phoneNumber');
    const codeControl = control.parent?.get('code');
    if (!phoneNumberControl || !codeControl) {
      return null;
    }

    let phoneNumberValue = phoneNumberControl.value as string;
    if (phoneNumberValue) {
      phoneNumberValue = phoneNumberValue.replace(/\s/g, '');
    }

    const codeValue = codeControl.value as string;
    let codeRealValue = '';
    if (codeValue.startsWith('+')) {
      codeRealValue = codeValue.split('+')[1];
    }
    if (phoneNumberValue && phoneNumberValue.startsWith(`+${codeRealValue}`) ||
      phoneNumberValue && phoneNumberValue.startsWith(`00${codeRealValue}`) ||
      phoneNumberValue && phoneNumberValue.startsWith(`${codeRealValue}`)) {
      return {'startWith': {value: control.value}};
    }
    return null;
  }

  static phoneMinLength(minLength: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;
      if (!value) {
        return null; // pozwól innym walidatorom obsłużyć przypadek pustej wartości
      }

      // Usuń wszystkie spacje z numeru telefonu
      const cleanValue = value.replace(/\s/g, '');

      // Sprawdź długość oczyszczonego numeru
      if (cleanValue.length < minLength) {
        return { 'minlength': { requiredLength: minLength, actualLength: cleanValue.length } };
      }

      return null;
    };
  }
}
